import * as ko from "knockout";
import WorkItem from "../work-item";
import BaseViewModel from "./../../factories/base-view-model2";
import TabPage from "./../../factories/tab-page";
import Bao from "./../../services/bao-service";

/**
 * ViewModel for WorkItemCheckwareTab
 */
class WorkItemCheckwareTab extends BaseViewModel {
    // #region Constructor

    /** 
     *Constructor
     */
    constructor(tabPage: TabPage, parent) {
        super(tabPage);
        this.TabPage = tabPage;
        this.WorkItem = parent;

        // Display the tab only for series definition
        if (this.WorkItem.PrimaryWorkItemId() != this.WorkItem.WorkItemId()) {
            this.TabPage.Visible(false);
            this.SetFirstVisibleTab();
        }

        this.SaveAllowed(false);
        this.NumberBoxLeadTime = {
            value: this.WorkItem.LeadTime,
            decimalDigits: 0,
            thousandSeperator: false,
            culture: Bao.Session.Language.Symbol()
        };
        this.WorkItemChecklistSearcher = {
            SearchType: 'FolderStructureChecklist',
            ObjectId: this.WorkItem.WorkItemFolderStructureChecklistId,
            ObjectValue: 'ChecklistName',
            AutoSearch: true,
            AutoComplete: true
        };

        this.TabTitle(tabPage.Title());
    }

    //  #endregion

    // #region Properties

    /**
     * Work Item Object
     */
    WorkItem: WorkItem;

    // Bao object to access session objects
    Bao = Bao;

    TabPage: TabPage;

    LeadTime = ko.observable<number>(0);

    //Controls
    NumberBoxLeadTime: Bindings.baoNumberBox;
    WorkItemChecklistSearcher: Bindings.baoSearcher;



    /**
     * Title of Page
     */
    TabTitle = ko.observable<string>("");

    /**
     * Name of save permission
     * */
    PermissionSave = ko.observable("");

    /**
     * Name of refresh permission
     * */
    PermissionRefresh = ko.observable("");

    /**
     * Name of delete permission
     * */
    PermissionDelete = ko.observable("");

    /**
     * Name of qr code permission
     * */
    PermissionQRCode = ko.observable("");

    // #endregion

    //#region Public Methods

    Refresh() {
        if (this.WorkItem.PrimaryWorkItemId() != this.WorkItem.WorkItemId()) {
            this.TabPage.Visible(false);
            this.SetFirstVisibleTab();
        } else {
            this.TabPage.Visible(true);
        }
    }

    InitUrl(): string {
        return "";
    }
    CompleteCheck(): boolean | JQueryPromise<boolean> {
        return true;
    }

    // #endregion

    // #region Protected Methods

    /**
     * Set the first visible tab
     */
    protected SetFirstVisibleTab() {
        if (this.TabPage.IsActiveTab()) {
            this.WorkItem.TabController.SelectTab(this.WorkItem.TabController.Tabs().find(t => t.Visible()), null, true);
        }
    }

    // #endregion
}
export default WorkItemCheckwareTab;